import store from '@/state/store';

export default (value) => {
    const badPhrases = store.getters['cfg/get'].global.badPhrases.content.toLowerCase().split(',');

    if (!value) {
        return true;
    }

    let isBad = false;
    value = value.toLowerCase();


    badPhrases.forEach(badPhrase => {
        if (value.includes(badPhrase))
            isBad = true;
    });

    return !isBad;
}